// extracted by mini-css-extract-plugin
export var calendarView = "_ks-0";